import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams, DateTime, AlertController } from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';
import { Event } from '../../models/Event';
import { DatePipe } from '@angular/common';
import { EventNextPage } from '../event-next/event-next';



@IonicPage()
@Component({
  selector: 'page-events',
  templateUrl: 'events.html',
})
export class EventsPage implements OnInit {
  EventsArray: Event[] = [];
  add_new_event: boolean = false;
  delete_event: boolean = false;
  event_id: number;
  event_name: string;
  event_start_date: any;
  event_end_date: any;
  event_start_time: any;
  event_end_time: any;
  delivered_by: string;
  event_details: string;
  sponsor: string;
  delete_event_id: number;
  edit_event: Event;
  today: any;
  disableButton: boolean = false;
  constructor(public navCtrl: NavController, public navParams: NavParams, private restProvider: RestProvider, private datePipe: DatePipe, private alertCtrl: AlertController) {
  }

  ngOnInit() {
    this.event_id = null;
    this.EventsArray = [];
    this.today = new Date().toISOString().substring(0, 10);
    this.GetEventDetails();
  }
  onKeyPress(event) {
    if ((event.keyCode >= 65 && event.keyCode <= 90) || (event.keyCode >= 97 && event.keyCode <= 122) || event.keyCode == 32 || event.keyCode == 46) {
      return true
    }
    else {
      return false
    }
  }
  getTimeDifference() {
    console.log("came inside ofgetTimeDifference() method")
    if (this.event_start_date > this.event_end_date) {
      let alert = this.alertCtrl.create({
        title: 'Alert',
        subTitle: 'End  Date should be greater than start date',
        buttons: [
          {
            text: 'Ok',
            handler: () => {
              console.log('Yes clicked');
              this.event_end_date = null;
              this.event_start_date = null;
            }
          }
        ]
      });
      alert.present();
      return;
    }

    if (this.event_start_time == null || this.event_end_time == null || this.event_start_date == null || this.event_end_date == null) {
      return;
    }
    let starthours: any;
    let endhours: any;
    console.log("est,eet", this.event_start_time, this.event_end_time)
    if (this.event_start_time) {
      starthours = this.event_start_time.split(':');
      //console.log(starthours[0]);
    }

    if (this.event_end_time) {
      endhours = this.event_end_time.split(':');
      //console.log(endhours[0]);
    }

    let start_am_pm: any;
    let end_am_pm: any;
    if (starthours[0] > 12) {
      start_am_pm = "PM";
      this.event_start_time + ' ' + start_am_pm;
    }
    else {
      start_am_pm = "AM";
      this.event_start_time + ' ' + start_am_pm
    }
    if (endhours[0] > 12) {
      end_am_pm = "PM";
      this.event_end_time + ' ' + end_am_pm;
    }
    else {
      end_am_pm = "AM";
      this.event_end_time + ' ' + end_am_pm;
    }


    let start = this.event_start_date + ' ' + this.event_start_time;
    let end = this.event_end_date + ' ' + this.event_end_time;
    console.log(start, end)
    //   var startTime = new Date('02/12/2013 10:00:00 PM');
    // var endTime = new Date('02/12/2013 11:00:00 AM');
    var startTime = new Date(start);
    var endTime = new Date(end);
    console.log("Finally est:", startTime);
    console.log("Finally eet:", endTime);

    if (startTime < endTime) {
      console.log("start time is lesser")
    }
    else {
      console.log("start time is greater");
      let alert = this.alertCtrl.create({
        title: 'Alert',
        subTitle: 'End time should be greater than start time.',
        buttons: [
          {
            text: 'Ok',
            handler: () => {
              console.log('Yes clicked');
              this.event_end_time = null;
              this.event_start_time = null;
            }
          }
        ]
      });
      alert.present();
      return;
    }

    // if(Date.parse(this.event_start_date + this.event_start_time) > Date.parse(this.event_end_date + this.event_end_time))
    // {

    // }
    // else{
    //   console.log("incorrect")
    //   let alert = this.alertCtrl.create({
    //     title: 'Alert',
    //     subTitle: 'Please enter valid end date',
    //     buttons: [
    //       {
    //         text: 'Ok',
    //         handler: () => {
    //           console.log('Yes clicked');
    //         }
    //       }
    //     ]
    //   });
    //   alert.present();
    //   return;
    // }

  }
  GetEventDetails() {
    let today = new Date();
    let cyear = today.getFullYear();
    let cmonth = today.getMonth() + 1;
    let cDate = today.getDate();
    let temp_date: string = "";
    let sMonth = (cmonth < 10)?'0'+cmonth:cmonth.toString();
    let sDate = (cDate < 10)?'0'+cDate:cDate.toString();
    temp_date = cyear + "-" + sMonth + "-" + sDate;
    console.log("temp_date", temp_date);
    this.EventsArray = [];
    this.restProvider.getEvents(temp_date).subscribe(
      (result: any) => {

        this.EventsArray = result;
        console.log(result)
        // for(let i = 0;i<result.length;i++)
        // {
        //   this.EventsArray.push(result[i])
        //   //this.EventsArray = result;
        // }
        console.log(this.EventsArray);
      },
      error => {
        console.log(error);
      }
    );
  }

  // OnNewEvent()
  // {
  //  this.add_new_event = true;
  // }

  CreateNewEvent() {
    this.disableButton = true;
    let post_event_obj = new Event;
    //post_event_obj.id = 1;
    // if(this.edit_event)
    // {
    //   post_event_obj.id = this.edit_event.id;
    // }
    post_event_obj.id = ((this.edit_event) ? this.edit_event.id : null);
    post_event_obj.eventname = this.event_name;
    // post_event_obj.eventstartdate = new Date(this.datePipe.transform(this.event_start_date,"yyyy-MM-dd HH:mm:ss"));
    // post_event_obj.eventenddate = new Date(this.datePipe.transform(this.event_end_date,"yyyy-MM-dd HH:mm:ss"));;
    // post_event_obj.eventstarttime = new Date(this.datePipe.transform(this.event_start_time,"yyyy-MM-dd HH:mm:ss"));;
    // post_event_obj.eventendtime = new Date(this.datePipe.transform(this.event_start_time,"yyyy-MM-dd HH:mm:ss"));;

    // post_event_obj.eventstartdate = new Date(this.datePipe.transform(this.event_start_date,"yyyy-MM-dd HH:mm:ss"));
    //post_event_obj.eventstartdate =     new Date(this.event_start_date.getFullYear(),this.event_start_date.getMonth(),this.event_start_date.getDate(),this.event_start_date.getHours(),this.event_start_date.getMinutes(),this.event_start_date.getSeconds());
    //post_event_obj.eventstartdate.toISOString().replace('Z', '').replace('T', '');

    //  post_event_obj.eventenddate = this.event_end_date;


    post_event_obj.eventstartdate = this.datePipe.transform(this.event_start_date, "yyyy-MM-dd");
    post_event_obj.eventenddate = this.datePipe.transform(this.event_end_date, "yyyy-MM-dd");
    //post_event_obj.eventstarttime = new Date(this.event_start_date.getFullYear(),this.event_end_date.getMonth(),this.event_start_date.getDate(),this.event_start_time.getHours(),this.event_start_time.getMinutes(),this.event_start_time.getSeconds())
    //post_event_obj.eventstarttime = this.datePipe.transform(this.event_start_date, "yyyy-MM-dd") + ' ' +this.event_start_time;
    // post_event_obj.eventendtime = this.datePipe.transform(this.event_end_date, "yyyy-MM-dd") + ' ' +this.event_end_time;;
    post_event_obj.eventstarttime = this.event_start_time;
    post_event_obj.eventendtime = this.event_end_time;

    post_event_obj.deliveredby = this.delivered_by;
    post_event_obj.eventdetails = this.event_details;
    post_event_obj.sponsor = this.sponsor;
    console.log("esd,eed :", this.event_start_date, this.event_end_date);
    console.log("est.edt :", this.event_start_time, this.event_end_time);
    console.log("obj", post_event_obj)
    if ((post_event_obj.eventname == null || post_event_obj.eventname == '') || (post_event_obj.eventstartdate == null) || (post_event_obj.eventenddate == null) || (post_event_obj.eventstarttime == null) || (post_event_obj.eventendtime == null) || (post_event_obj.deliveredby == null || post_event_obj.deliveredby == ' ')) {
      let alert = this.alertCtrl.create({
        title: 'Alert',
        subTitle: 'Please enter the event data',
        enableBackdropDismiss: false,
        buttons: [
          {
            text: 'Ok',
            handler: () => {
              console.log('Yes clicked');
              this.disableButton = false;
            }
          }
        ]
      });
      alert.present();
      return;
    }
    let searchforid = this.EventsArray.find((item) => { return item.eventname == post_event_obj.eventname })
    // if(searchforid)
    // {
    //   console.log("we already have an event with same name in our list")
    //   if(searchforid.eventstartdate == post_event_obj.eventstartdate)
    //   {
    //     console.log("we already have an event with same name ,start date in our list")
    //     if(searchforid.eventenddate == post_event_obj.eventenddate)
    //     {
    //       console.log("we already have an event with same name ,end date in our list")
    //       if(searchforid.eventstarttime == post_event_obj.eventstarttime)
    //       {
    //         console.log("we already have an event with same name ,start time in our list")
    //         if(searchforid.eventendtime == post_event_obj.eventendtime)
    //         {
    //           console.log("we already have an event with same name ,end time in our list")
    //           if(searchforid.deliveredby == post_event_obj.deliveredby)
    //           {
    //             console.log("we already have an event with same name ,del by in our list")
    //             if(searchforid.sponsor == post_event_obj.sponsor)
    //             {
    //               console.log("we already have an event with same name ,sponsor in our list")
    //               if(searchforid.eventdetails == post_event_obj.eventdetails)
    //               {
    //                 console.log("we already have an event with same name ,deatails in our list")
    //                 console.log("event already exists")
    //                 let alert = this.alertCtrl.create({
    //                   title: 'Alert',
    //                   subTitle: 'Event already exists',
    //                   buttons: [
    //                     {
    //                       text: 'Ok',
    //                       handler: () => {
    //                         console.log('Yes clicked');
    //                         this.disableButton = false;
    //                         this.Cancel();
    //                       }
    //                     }
    //                   ]
    //                 });
    //                 alert.present();
    //                 return;
    //               }
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }




    //   // return false;
    //   //post_event_obj.id = searchforid.id;
    // }
    //  else
    //  {
    this.restProvider.postEvent(post_event_obj).subscribe((result) => {
      this.disableButton = false;
      post_event_obj.id = null;
      console.log(result);
      this.Cancel();

      this.GetEventDetails();

    },
      error => {
        console.log(error);
        console.log(error.statusText);
        this.disableButton = false;
        let alert = this.alertCtrl.create({
          title: 'Alert',
          subTitle: 'Event not created',
          enableBackdropDismiss: false,
          buttons: [
            {
              text: 'Ok',
              handler: () => {
                console.log('Yes clicked');
                this.disableButton = false;
              }
            }
          ]
        });
        alert.present();

      })
    //}
    //this.disableButton = false;

    //this.GetEventDetails();
  }
  OnDeleteEvent(id) {
    console.log("event for deletion:", id)
    this.delete_event = true;
    //this.delete_event_id = id;
    if (id == null) {
      let alert = this.alertCtrl.create({
        title: 'Alert',
        subTitle: 'Please enter the event id',
        enableBackdropDismiss: false,
        buttons: [
          {
            text: 'Ok',
            handler: () => {
              console.log('Yes clicked');
            }
          }
        ]
      });
      alert.present();
      return;
    }
    let alert1 = this.alertCtrl.create({
      title: 'Alert',
      subTitle: 'Are you sure you want to delete the event?',
      buttons: [
        {
          text: 'No',
          role: 'Cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Yes',
          handler: () => {
            console.log('Yes clicked');

            //calling rest method to delete the event
            console.log("delete id:", id);
            this.restProvider.deleteEvent(id).subscribe((result) => {
              console.log("delete result:", result)
              let x = this.EventsArray.findIndex((item) => { return item.id == result })
              if (x) {
                this.EventsArray.splice(x, 0);
                console.log("EventsArray after deletion:", this.EventsArray);
                this.Cancel();
                this.GetEventDetails();
              }
            },
              error => {
                console.log(error);
                let alert = this.alertCtrl.create({
                  title: 'Alert',
                  subTitle: 'Event not Deleted',
                  enableBackdropDismiss: false,
                  buttons: [
                    {
                      text: 'Ok',
                      handler: () => {
                        console.log('Yes clicked');
                      }
                    }
                  ]
                });
                alert.present();
              })

          }
        }
      ]
    });

    alert1.present();
    this.delete_event_id = null;
    this.delete_event = false;
  }
  EditEvent(event: Event) {
    this.disableButton = false;
    if (event) {
      this.edit_event = event;
    }
    console.log("event for editing:", event)
    this.event_id = event.id;
    this.event_name = event.eventname;
    //let tstartdate = new Date(event.eventstartdate).toISOString();
    //this.event_start_date = new Date(this.datePipe.transform((tstartdate),"yyyy/MM/dd"));
    this.event_start_date = this.datePipe.transform(event.eventstartdate, 'yyyy-MM-dd')
    this.event_end_date = this.datePipe.transform(event.eventenddate, 'yyyy-MM-dd')
    console.log(typeof (event.eventstartdate), this.event_start_date);
    this.event_start_time = this.datePipe.transform(event.eventstarttime, 'HH:mm');
    // this.event_start_time = new Date(this.datePipe.transform(event.eventstarttime,'HH:mm'));
    this.event_end_time = this.datePipe.transform(event.eventendtime, 'HH:mm');
    this.delivered_by = event.deliveredby;
    this.sponsor = event.sponsor;
    this.event_details = event.eventdetails;
  }
  Cancel() {
    this.event_name = null;
    this.event_start_date = null;
    this.event_start_time = null;
    this.event_end_date = null;
    this.event_end_time = null;
    this.delivered_by = null;
    this.sponsor = null;
    this.event_details = null;
    this.event_id = null;
  }
  GotoEventNextPage() {
    this.navCtrl.push(EventNextPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/events/events.ts